<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('products.product_classes.form.name')"
            :is-required="true"
            :error="errors.name"
        >
            <DInput
                id="name"
                v-model="form.name"
                :is-valid="isFormFieldValid('name')"
                maxlength="32"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.product_classes.form.active')"
            :is-required="true"
        >
            <DSwitch
                v-model="form.active"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="cancelRoute"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { computed } from 'vue'
import { route } from '~@/Composables/route'

const props = defineProps({
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    },
    productClass: {
        type: Object,
        default: () => { return {} }
    }
})
const emit = defineEmits(['form-submitted'])

const cancelRoute = computed(() => route('products.product-classes.index'))

const form = useForm({
    name: props.productClass?.name ?? null,
    active: props.productClass?.active ?? false
})
function submitForm () {
    emit('form-submitted', form)
}
</script>
